// extracted by mini-css-extract-plugin
export default {"container":"History_container__GcDNr","table-container":"History_table-container__u8++2"};